import { StyleSheet } from "react-native";
import { Check, Plus } from "lucide-react-native";
import { colors } from "@tabbio/tokens";
import { NativeButton } from "../common/NativeButton";
import { useTheme } from "../../hooks/useTheme";

/** The same wrapping pill used for work arrangements, countries and alert frequency. */
export function JobPreferencePill({
  label,
  selected,
  onPress,
  exclusive = false,
}: {
  label: string;
  selected: boolean;
  onPress: () => void;
  exclusive?: boolean;
}) {
  const { theme } = useTheme();
  const foreground = selected ? "#ffffff" : theme.text;
  return (
    <NativeButton
      title={label}
      onPress={onPress}
      pill
      size="sm"
      haptic="selection"
      accessibilityRole={exclusive ? "radio" : "checkbox"}
      accessibilityState={exclusive ? { selected } : { checked: selected }}
      style={{
        ...styles.pill,
        backgroundColor: selected ? colors.primary : theme.surfaceSecondary,
      }}
      textStyle={styles.label}
      textColor={foreground}
      iconRight={
        selected ? (
          <Check size={14} color={foreground} />
        ) : !exclusive ? (
          <Plus size={14} color={foreground} />
        ) : undefined
      }
    />
  );
}

export const jobPreferenceStyles = StyleSheet.create({
  section: { gap: 10 },
  label: { fontSize: 16, fontWeight: "600", paddingHorizontal: 4 },
  help: { fontSize: 14, lineHeight: 20, paddingHorizontal: 4 },
  input: {
    minHeight: 52,
    borderRadius: 28,
    paddingHorizontal: 20,
    paddingVertical: 14,
    fontSize: 14,
  },
  row: { flexDirection: "row", flexWrap: "wrap", gap: 6 },
});

const styles = StyleSheet.create({
  pill: {
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "flex-start",
    gap: 6,
    borderRadius: 50,
    paddingHorizontal: 16,
    paddingVertical: 8,
    height: "auto",
    minHeight: 34,
    maxWidth: "100%",
  },
  label: { fontSize: 14, fontWeight: "500", flexShrink: 1 },
});
